/**
 * Get base path
 * @returns {string}
 */
window.getBasePath = function() {
  if (document.querySelector('meta[name="BASE_PATH"]')) {
    return document.querySelector('meta[name="BASE_PATH"]').getAttribute('content');
  }

  return '';
};

/**
 * Load lang strings
 * @returns {any}
 */
window.loadLangStrings = function() {
  if (document.querySelector('meta[name="LANG_STRINGS"]')) {
    var langStringsMetaTag = document.querySelector('meta[name="LANG_STRINGS"]');
    var langStringsContent = langStringsMetaTag.getAttribute('content');

    // das JSON parsen, um ein JavaScript-Objekt zu erhalten
    return JSON.parse(langStringsContent);
  } else {
    return {};
  }
};

/**
 * Load lang strings
 * @returns {any}
 */
window.loadAdditionalLangStrings = function() {
  if (document.querySelector('meta[name="ADDITIONAL_LANG_STRINGS"]')) {
    var langStringsMetaTag = document.querySelector('meta[name="ADDITIONAL_LANG_STRINGS"]');
    var langStringsContent = langStringsMetaTag.getAttribute('content');

    // das JSON parsen, um ein JavaScript-Objekt zu erhalten
    return JSON.parse(langStringsContent);
  } else {
    return {};
  }
};

// Export defined list
module.exports = {
  //BASE_PATH: getBasePath(),
  //LANG_STRINGS: loadLangStrings(),
  ADDITIONAL_LANG_STRINGS: loadAdditionalLangStrings(),
};